/** Lista fija de tipos de identificación tributaria admitidos por el backend (máx 30). */
export const IDENTIFICATION_TYPES: readonly string[] = ['RUC', 'NIT', 'RFC', 'NIF/CIF', 'DNI', 'Otro'];

export interface BusinessAdminInfo {
  id: number;
  email: string;
  fullname: string;
  lastname?: string | null;
  roleId?: number | null;
  roleName?: string | null;
}

export interface BusinessResponse {
  id: number;
  name: string;
  description?: string | null;
  identificationNumber?: string | null;
  identificationType?: string | null;
  address?: string | null;
  phone?: string | null;
  isActive?: boolean | null;
  datetimeCreate?: string | null;
  updatedAt?: string | null;
  defaultTimezone?: string | null;
  admins?: BusinessAdminInfo[] | null;
  logoUrl?: string | null;
  defaultCurrencyId?: number | null;
  defaultCurrencyCode?: string | null;
  defaultCurrencyName?: string | null;
  /**
   * true = empresa PROVEEDORA (la dueña del CRM, donde viven los Super Admin). Es única
   * y el backend impide desactivarla o eliminarla: si se pudiera, desactivar todas las
   * empresas dejaba al Super Admin sin poder iniciar sesión ni revertirlo. La UI debe
   * deshabilitar el toggle de estado y el botón de eliminar cuando viene true.
   */
  isProvider?: boolean | null;
  /**
   * INC 15 — alta atómica: sólo viene en la respuesta 201 de POST /api/businesses
   * cuando se envió `adminMail`. `null` = no se pidió invitación.
   */
  adminInvitationSent?: boolean | null;
  /** Mensaje accionable en español cuando `adminInvitationSent === false`. */
  adminInvitationError?: string | null;
}

export interface BusinessRequest {
  name: string;
  description?: string | null;
  identificationNumber?: string | null;
  identificationType?: string | null;
  address?: string | null;
  phone?: string | null;
  isActive?: boolean | null;
  defaultTimezone?: string | null;
  logoUrl?: string | null;
  defaultCurrencyId?: number | null;
  /**
   * INC 15 — correo del administrador a invitar. SOLO se envía en POST (alta): el
   * backend crea la empresa y la invitación con rol Admin en el mismo flujo.
   * En PUT se IGNORA (editar nunca crea invitaciones).
   */
  adminMail?: string | null;
}

/** INC 15 — GET /api/businesses/{id}/admin-invitation */
export interface BusinessAdminInvitation {
  id: number;
  businessId: number;
  mailInvited: string;
  status: 'PENDING' | 'ACCEPTED' | 'EXPIRED' | 'REVOKED';
  roleId?: number | null;
  expiresAt?: string | null;
  createdAt?: string | null;
  invitationLink?: string | null;
}
